import React from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchInset,
  DemoWorkbenchPill,
} from "@csk/demo-ui";

interface SnapshotEntry {
  readonly id?: string;
  readonly path?: string;
}

interface SnapshotIndex {
  readonly snapshots?: readonly SnapshotEntry[];
}

export function SnapshotPanel(props: {
  index: SnapshotIndex | null;
}): React.JSX.Element {
  if (!props.index)
    return (
      <DemoWorkbenchCard
        title="Snapshots"
        right={<DemoWorkbenchPill>optional</DemoWorkbenchPill>}
      >
        <div className="text-sm text-slate-300">
          Provide <code>public/data/snapshot-index.json</code>.
        </div>
      </DemoWorkbenchCard>
    );
  const snaps: readonly SnapshotEntry[] = Array.isArray(props.index.snapshots)
    ? props.index.snapshots
    : [];
  return (
    <DemoWorkbenchCard
      title="Snapshots"
      right={<DemoWorkbenchPill>{snaps.length}</DemoWorkbenchPill>}
    >
      <div className="text-sm text-slate-300">
        These are governance snapshots for δ-diff and promotion.
      </div>
      <div className="mt-3 space-y-2">
        {snaps.map((s, i: number) => (
          <DemoWorkbenchInset
            key={i}
            compact
            title={s.id ?? ""}
            right={<DemoWorkbenchPill>{s.path ?? ""}</DemoWorkbenchPill>}
          />
        ))}
      </div>
    </DemoWorkbenchCard>
  );
}
